import List from "@/components/list";
import vue from "@/main";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};

  // 删除分类
  function deleteCategory(category) {
    vue.$emit("deleteCategory", category);
  }
  // 编辑分类
  function update(category) {
    vue.$emit("curdCategory", category);
  }

  function showDetail(vo) {
    vue.$emit("showImg", vo.row);
  }

  const Deal = ({ props: { vo } }) => {
    const category = vo.row;
    const dealConf = [
      ["icon-edit", "编辑", () => update(category), "shortCategory:update"],
      [
        "icon-delete",
        "删除",
        () => deleteCategory(category),
        "shortCategory:delete"
      ]
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const Img = ({ props: { vo } }) => {
    return (
      <div onClick={() => showDetail(vo)}>
        <img src={vo.row.iconUrl} style="width:30%" />
      </div>
    );
  };
  const AccountTableConfig = [
    // {
    //   type: "selection",
    //   label: "main"
    // },
    {
      label: "分类名称",
      prop: "categoryName",
      minWidth: "180",
      showOverflowTooltip: true
    },
    {
      label: "品类图标",
      prop: "leaderUserName",
      minWidth: "150",
      render: vo => <Img vo={vo} />
    },
    {
      label: "状态",
      prop: "onlineStatusName",
      minWidth: "150"
    },
    {
      label: "操作",
      fixed: "right",
      minWidth: "100",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...args}
      empty-text="尚未添加任何分类，点击左上角【添加】可进行分类添加"
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
